import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "@mui/material/Collapse";
import "./style.css";

interface MenuItem {
  id: string;
  title: string;
  link?: string;
  submenu?: MenuItem[];
}

const menus: MenuItem[] = [
  { id: "home", title: "Home", link: "/" },
  {
    id: "about", title: "About", link: "/about",
    submenu: [
      { id: "about-digicomm", title: "About Digicomm", link: "/about" },
      { id: "leadership", title: "Leadership", link: "/team" },
      { id: "why-digicomm", title: "Why Digicomm", link: "/why-digicomm" },
    ],
  },
  {
    id: "services", title: "Services", link: "/service",
    submenu: [
      {
        id: "core", title: "Core Engineering Services", link: "/service",
        submenu: [
          { id: "asic", title: "ASIC & SoC Design", link: "/services/asic-soc-design" },
          { id: "verification", title: "Verification Services", link: "/services/verification" },
          { id: "physical", title: "Physical Design", link: "/services/physical-design" },
          { id: "dft", title: "DFT Services", link: "/services/dft" },
          { id: "silicon", title: "Silicon Realization", link: "/services/silicon-realization" },
        ],
      },
      {
        id: "specialized", title: "Specialized Engineering Services", link: "/service",
        submenu: [
          {
            id: "advanced", title: "Advanced Design & Implementation",
            submenu: [
              { id: "analog", title: "Analog & Mixed Signal Design & Layout", link: "/services/analog-mixed-signal" },
              { id: "sta", title: "Static Timing Analysis (STA)", link: "/services/static-timing-analysis" },
              { id: "fpga", title: "FPGA Engineering", link: "/services/fpga-engineering" },
            ],
          },
          {
            id: "software", title: "Software, Platforms & Infrastructure",
            submenu: [
              { id: "embedded", title: "Embedded Software Systems", link: "/services/embedded-software-systems" },
              { id: "hardware", title: "Hardware Platform Engineering", link: "/services/hardware-platform-engineering" },
              { id: "networking", title: "Networking Solutions", link: "/services/networking-solutions" },
            ],
          },
          {
            id: "validation", title: "Validation, Automation & Product Engineering",
            submenu: [
              { id: "silicon-validation", title: "Silicon Validation", link: "/services/silicon-validation" },
              { id: "eda", title: "EDA & Design Automation", link: "/services/eda-design-automation" },
              { id: "product-engineering", title: "Product Engineering", link: "/services/product-engineering" },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "solutions", title: "Solutions", link: "/solutions",
    submenu: [
      { id: "team-extension", title: "Engineering Team Extension", link: "/solutions/engineering-team-extension" },
      { id: "project-ownership", title: "Project Ownership & Managed Engineering", link: "/solutions/project-ownership" },
      { id: "end-to-end", title: "End-to-End Silicon Development", link: "/solutions/end-to-end-silicon-development" },
      { id: "product-design", title: "Engineering Productivity & Design Automation", link: "/solutions/engineering-product-design" },
      { id: "product-realization", title: "Product Realization & Deployment", link: "/solutions/product-realization" },
    ],
  },
  { id: "ip-accelerators", title: "IP & Accelerators", link: "/ip-accelerators" },
  { id: "industries", title: "Industries", link: "/industries" },
  {
    id: "resources", title: "Resources",
    submenu: [
      { id: "insights", title: "Insights & Articles", link: "/blog" },
      { id: "careers", title: "Careers", link: "/career" },
    ],
  },
  { id: "contact", title: "Contact", link: "/contact" },
];

const MobileMenuItem: React.FC<{ item: MenuItem; level?: number }> = ({ item, level = 0 }) => {
  const [open, setOpen] = useState(false);
  const navigate = () => window.scrollTo({ top: 0, behavior: "smooth" });

  if (!item.submenu) {
    return <li className={`mobile-menu-level-${level}`}><Link to={item.link || "#"} onClick={navigate}>{item.title}</Link></li>;
  }

  return (
    <li className={`${open ? "active" : ""} mobile-menu-level-${level}`}>
      <Fragment>
        <div className="mobile-menu-row">
          <button
            type="button"
            className="mobile-menu-title-button"
            onClick={() => setOpen(!open)}
            aria-expanded={open}
            aria-label={`${open ? "Collapse" : "Expand"} ${item.title}`}
          >
            <span>{item.title}</span>
          </button>
          <button type="button" onClick={() => setOpen(!open)} aria-expanded={open} aria-label={`Toggle ${item.title}`}>
            <i aria-hidden="true"></i>
          </button>
        </div>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <ul className="subMenu">
            {item.submenu.map((child) => <MobileMenuItem key={child.id} item={child} level={level + 1} />)}
          </ul>
        </Collapse>
      </Fragment>
    </li>
  );
};

const MobileMenu: React.FC = () => (
  <ul className="responsivemenu digicomm-mobile-menu">
    {menus.map((menu) => <MobileMenuItem key={menu.id} item={menu} />)}
  </ul>
);

export default MobileMenu;
